import { Injectable, inject } from '@angular/core';
import {
  IQueryParam,
  IListado,
  IFacturacionCliente,
  ICreateFacturacionCliente,
  IUpdateFacturacionCliente,
} from 'modelos/src';
import { HttpClientService } from '../http.service';
import { HelperService } from '../helper.service';

@Injectable({
  providedIn: 'root',
})
export class FacturacionClientesService {
  private http = inject(HttpClientService);

  public getFiltered(
    queryParams?: IQueryParam,
  ): Promise<IListado<IFacturacionCliente>> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`/facturacionclientes`, { params });
  }

  public getById(id: string): Promise<IFacturacionCliente> {
    return this.http.get(`/facturacionclientes/${id}`);
  }

  public create(
    dato: ICreateFacturacionCliente,
  ): Promise<IFacturacionCliente> {
    return this.http.post(`/facturacionclientes`, dato);
  }

  public update(
    id: string,
    dato: IUpdateFacturacionCliente,
  ): Promise<IFacturacionCliente> {
    return this.http.put(`/facturacionclientes/${id}`, dato);
  }

  public delete(id: string): Promise<void> {
    return this.http.delete(`/facturacionclientes/${id}`);
  }
}
